import React from 'react';
import { Link } from 'gatsby';
import { cva } from 'class-variance-authority';
import { cnMerge } from '../../../utils/utils';

export const IconLink = ({
  href,
  title,
  clickable = true,
  children,
  className,
  external = false,
  trackingFn,
  ...props
}) => {
  const iconLinkVariants = cva(
    'inline-flex items-center justify-center ring-offset-background',
    {
      variants: {
        clickable: {
          default:
            'hover:transition-opacity hover:opacity-75 hover:duration-[0.3s] hover:ease-[ease]',
          true: 'hover:transition-opacity hover:opacity-75 hover:duration-[0.3s] hover:ease-[ease]',
          false: 'cursor-auto pointer-events-none',
        },
      },
      defaultVariants: {
        clickable: 'default',
      },
    }
  );

  if (external || href?.includes('://') || href?.indexOf('mailto:') === 0) {
    return (
      <a
        href={clickable ? href : '#'}
        title={title ?? ''}
        target="_blank"
        rel="nofollow noopener"
        onClick={() => {
          trackingFn();
        }}
        className={cnMerge(
          iconLinkVariants({
            clickable,
          }),
          className
        )}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children ?? label}
      </a>
    );
  }

  return (
    <Link
      to={clickable ? href : '#'}
      title={title ?? ''}
      onClick={clickable ? () => {} : (e) => e.preventDefault()}
      className={cnMerge(
        iconLinkVariants({
          clickable,
        }),
        className
      )}
      {...props}
    >
      {children}
    </Link>
  );
};
